import { useState, type ReactNode } from 'react';
import { apiUrl } from '../lib/consts';

interface Props {
    title: string;
    description?: ReactNode;
    error?: string;
    footer?: ReactNode;
    children: ReactNode;
}

export default function AuthPageLayout({ title, description, error, footer, children }: Props) {
    // Public endpoint (tenant resolved by subdomain); 404 when there is no logo.
    const [hasCustomerLogo, setHasCustomerLogo] = useState(true);

    return (
        <div className="min-h-screen flex items-center justify-center p-4">
            <div className="w-full max-w-md">
                <div className="flex justify-center items-center gap-2 mb-8">
                    <img src="/logo.svg" alt="Navaris" className="w-12 h-12" />
                    <h1 className="text-3xl font-bold text-offwhite">Navaris</h1>
                </div>

                <div className="bg-white rounded-2xl p-8 border border-softgrey navaris-lifted">
                    {/* On the white card, so any logo is legible whatever its colours. */}
                    {hasCustomerLogo && (
                        <img
                            src={`${apiUrl}/workspace/logo`}
                            alt=""
                            className="max-h-14 max-w-[70%] object-contain mx-auto mb-6"
                            onError={() => setHasCustomerLogo(false)}
                        />
                    )}
                    <h2 className={`text-xl font-semibold text-graphite ${description ? 'mb-2' : 'mb-6'}`}>{title}</h2>
                    {description && <p className="text-coolslate mb-6">{description}</p>}

                    {error && (
                        <div className="bg-state-error/10 border border-state-error/30 text-state-error px-4 py-3 rounded-lg mb-6">
                            {error}
                        </div>
                    )}

                    {children}

                    {footer && <div className="mt-6 text-center">{footer}</div>}
                </div>
            </div>
        </div>
    );
}
